export default {
  text: 'Tämä ravintola on jäädytetty. Ota yhteyttä yhteyshenkilöösi tai lähetä meille viesti osoitteeseen <a>{{supportEmail}}</a>, jos haluat palauttaa sen',
};
